import { Box, Card, Checkbox, CircularProgress, FormControl, Button, FormControlLabel, Grid, IconButton, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, Stack, Typography, Chip, Badge, FormHelperText, TextField } from '@mui/material'
import AngleRightIcon from 'common/customIcons/angle_right'
import CommonLayout from 'layouts/DashboardLayout'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { fetchDriversRegions } from '../../../../redux/slices/hyperwolf/driver/driverRegion'
import MDButton from 'components/MDButton'
import { useSelector } from 'react-redux'
import { openCustomModalDialog } from '../../../../redux/slices/modalSlice'
import defaultImage from 'assets/images/placeholder-image.png';
import { openSnackbar } from '../../../../redux/slices/common'
import { CreateBRBGraphic, CreateHolidayManagement, fetchHolidayByID, updateHolidayByID } from '../../../../redux/slices/hyperwolf/settings'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import CalendarIcon from 'common/customIcons/calendar'
import moment from 'moment'
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import Loader from 'common/Loader'


const selectAll = {
  m: 0,
  mb: 0.5,
  padding: '4.5px 8px',
  borderRadius: '0.375rem',
  transition: 'background-color 300ms ease, color 300ms ease',
  ':hover': {
    backgroundColor: '#f0f2f5'
  }
};
const uploadThumbnailImage = {
  borderRadius: '20px',
  width: '160px',
  height: '160px',
  objectFit: 'cover',
  boxShadow: '0 0 1px rgb(0 0 0 / 20%)'
};

const badgeCircularProgressIcon = {
  backgroundColor: '#ffffff',
  borderRadius: 10,
  p: .5,
  mr: 14,
  mt: 14
};

const EditHolidayByDate = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [regionData, setRegionData] = useState([])
  const [formData, setFormData] = useState({
    holidayDate: "",
    regionGroups: [
      {
        id: 1,
        regions: [],
        desktopImage: null,
        mobileImage: null
      }
    ]
  });
  const { isUploading = false } = useSelector((state => state.common));
  const uploadedImageRef = useRef();
  const [errors, setErrors] = useState({});
  const [desktopImageModalOpen, setDesktopImageModalOpen] = useState({});
  const [mobileImageModalOpen, setMobileImageModalOpen] = useState({});
  const [activeGroupForImage, setActiveGroupForImage] = useState(null);
  const [activeImageType, setActiveImageType] = useState(null);
  const { isLoading, isUpdateLoading } = useSelector(state => state.hyperwolfSettings);
  const { user } = useSelector(state => state.auth);
  const DateRef = useRef('')
  const { HolidayDate } = useParams(); // Get date from URL

  const ITEM_HEIGHT = 96;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      },
    },
  };


    // Get all selected region IDs across all groups
    const getAllSelectedRegionIds = () => {
      return formData.regionGroups.flatMap(group => group.regions || []);
  };

  // Check if all regions are used across all groups
  const areAllRegionsUsed = () => {
      const allSelectedIds = getAllSelectedRegionIds();
      return regionData.length > 0 && allSelectedIds.length >= regionData.length;
  };

  // Get available regions (not selected in any group)
  const getAvailableRegions = () => {
      const allSelectedIds = getAllSelectedRegionIds();
      return regionData.filter(region => !allSelectedIds.includes(region.id));
  };

  // Check if a region is disabled (already selected in another group)
  const isRegionDisabled = (regionId, currentGroupId) => {
      const allSelectedIds = getAllSelectedRegionIds();
      const isSelectedInOtherGroup = allSelectedIds.includes(regionId) &&
          !formData.regionGroups.find(group => group.id === currentGroupId)?.regions?.includes(regionId);
      return isSelectedInOtherGroup;
  };
  

  useEffect(() => {
    dispatch(fetchDriversRegions())
      .then((res) => {
        if (res?.payload) {
          setRegionData(res.payload.data.regions)
        }
      })
      .catch((err) => { });
  }, [dispatch])

  const isAllDriverSelected = (regions) => {
    return regionData?.length > 0 && regions?.length === regionData?.length;
  };

  const handleRemoveRegion = (groupId, regionId) => {
    const updatedGroups = formData.regionGroups.map(group => {
      if (group.id === groupId) {
        return {
          ...group,
          regions: group.regions.filter(id => id !== regionId)
        };
      }
      return group;
    });
    setFormData({ ...formData, regionGroups: updatedGroups });
  };

  const handleRemoveAllRegions = (groupId) => {
    const updatedGroups = formData.regionGroups.map(group => {
      if (group.id === groupId) {
        return {
          ...group,
          regions: []
        };
      }
      return group;
    });
    setFormData({ ...formData, regionGroups: updatedGroups });
  };

  const handleRemoveGroup = (groupId) => {
    if (formData.regionGroups.length > 1) {
      const updatedGroups = formData.regionGroups.filter(group => group.id !== groupId);
      setFormData({ ...formData, regionGroups: updatedGroups });

      // Close modals if open for this group
      setDesktopImageModalOpen(prev => {
        const newState = { ...prev };
        delete newState[groupId];
        return newState;
      });
      setMobileImageModalOpen(prev => {
        const newState = { ...prev };
        delete newState[groupId];
        return newState;
      });
    }
  };

  const handleAddRegionGroup = () => {
    // Don't add new group if all regions are already used
    if (areAllRegionsUsed()) {
      return;
    }
    
    const newGroupId = Math.max(...formData.regionGroups.map(g => g.id), 0) + 1;
    const newGroup = {
      id: newGroupId,
      regions: [],
      desktopImage: null,
      mobileImage: null
    };
    setFormData({
      ...formData,
      regionGroups: [...formData.regionGroups, newGroup]
    });
  };

  const handleImageOpenModal = async (type, groupId, mediaType) => {

    const dimensions = mediaType === 'desktopImage' ? `1252x560` : `406x180`
    setActiveGroupForImage(groupId);
    setActiveImageType(mediaType);
    dispatch(
      openCustomModalDialog({
        modalData: {
          type: type,
          dimensions: dimensions,
          handleSave: (data) => handleSave(data, groupId, mediaType)
        },
        modal: "ADD_DEVICE_IMAGE_MODAL"
      })
    );
  };

  const handleSave = (data, groupId, mediaType) => {
    if (data?.type === 'desktopImage' && groupId && mediaType) {
      const updatedGroups = formData.regionGroups.map(group => {
        if (group.id === groupId) {
          return {
            ...group,
            [mediaType]: {
              imageUrl: data?.desktopImage?.imageUrl,
              title: data?.imageTitle,
              description: "",
              altText: data?.altText,
              mediaType: data?.desktopImage?.mediaType
            }
          };
        }
        return group;
      });
      setFormData({ ...formData, regionGroups: updatedGroups });

      // Clear the specific image error when image is uploaded
      if (errors[groupId] && errors[groupId][mediaType]) {
        const newErrors = { ...errors };
        delete newErrors[groupId][mediaType];
        if (Object.keys(newErrors[groupId]).length === 0) {
          delete newErrors[groupId];
        }
        setErrors(newErrors);
      }
    }
  };

  const toggleDesktopImageModal = (groupId) => {
    setDesktopImageModalOpen(prev => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };

  const toggleMobileImageModal = (groupId) => {
    setMobileImageModalOpen(prev => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };

  const getSelectedRegionNames = (regionIds) => {
    return regionData.filter(region => regionIds.includes(region.id));
  };

  const updateGroupRegions = (groupId, newRegions) => {
    // Filter out any regions that are already selected in other groups (except current group)
    const availableRegions = getAvailableRegions();
    const currentGroupRegions = formData.regionGroups.find(group => group.id === groupId)?.regions || [];
    
    // Only allow regions that are either already in this group or available
    const filteredRegions = newRegions.filter(regionId => 
        currentGroupRegions.includes(regionId) || 
        availableRegions.some(region => region.id === regionId)
    );
    const updatedGroups = formData.regionGroups.map(group => {
      if (group.id === groupId) {
        return {
          ...group,
          regions: filteredRegions
        };
      }
      return group;
    });
    setFormData({ ...formData, regionGroups: updatedGroups });
  };

  const removeImage = (groupId, mediaType) => {
    const updatedGroups = formData.regionGroups.map(group => {
      if (group.id === groupId) {
        return {
          ...group,
          [mediaType]: null
        };
      }
      return group;
    });
    setFormData({ ...formData, regionGroups: updatedGroups });
  };

  // Clear specific error for a group and field
  const clearError = (groupId, fieldName) => {
    if (errors[groupId] && errors[groupId][fieldName]) {
      const newErrors = { ...errors };
      delete newErrors[groupId][fieldName];
      if (Object.keys(newErrors[groupId]).length === 0) {
        delete newErrors[groupId];
      }
      setErrors(newErrors);
    }
  };

  // Validation function
  const validateForm = () => {
    const newErrors = {};

    // Description (overall) validation
    if (!formData.description || formData.description.trim() === "") {
      newErrors.description = 'Description is required';
    }

    formData.regionGroups.forEach((group, index) => {
      const groupErrors = {};

      // Validate at least one region is selected
      if (!group.regions || group.regions.length === 0) {
        groupErrors.regions = 'At least one region is required';
      }

      // Validate desktop image
      if (!group.desktopImage || !group.desktopImage.imageUrl) {
        groupErrors.desktopImage = 'Desktop image is required';
      }

      // Validate mobile image
      if (!group.mobileImage || !group.mobileImage.imageUrl) {
        groupErrors.mobileImage = 'Mobile image is required';
      }

      if (Object.keys(groupErrors).length > 0) {
        newErrors[group.id] = groupErrors;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const ImageUploadSection = ({ group, mediaType, title, dimensions, toggleModal, modalOpen }) => {
    const media = group[mediaType];
    const hasError = errors[group.id] && errors[group.id][mediaType];
    const isVideo = media?.mediaType === 'video' || media?.url?.match(/\.(mp4|webm|ogg)$/i);

    // Function to handle image selection/upload
    const handleImageSelect = () => {
      toggleModal(group.id);
      handleImageOpenModal("desktop", group.id, mediaType);
    };

    return (
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" fontWeight="medium" mb={1}>
          {title}
        </Typography>
        <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25}>
          <Badge
            overlap='circular'
            anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
            badgeContent={
              isUploading && activeGroupForImage === group.id && activeImageType === mediaType ?
                <CircularProgress size={32} color='primary' sx={badgeCircularProgressIcon} /> : ''
            }
          >
            {media?.imageUrl || media?.url ? (
              <Box sx={{ position: 'relative', display: 'inline-block' }}>
                {/* Show video if it's a video file */}
                {isVideo ? (
                  <Box
                    sx={{
                      ...uploadThumbnailImage,
                      border: hasError ? '2px solid #fd4438' : 'none',
                      boxShadow: hasError ? '0 0 0 1px #fd4438' : '0 0 1px rgb(0 0 0 / 20%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#f5f5f5'
                    }}
                  >
                    <video
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '6px'
                      }}
                      controls
                    >
                      <source src={media?.url || media?.imageUrl} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </Box>
                ) : (
                  // Show image if it's an image file
                  <img
                    style={{
                      ...uploadThumbnailImage,
                      border: hasError ? '2px solid #fd4438' : 'none',
                      boxShadow: hasError ? '0 0 0 1px #fd4438' : '0 0 1px rgb(0 0 0 / 20%)',
                      borderRadius: '6px'
                    }}
                    src={media?.imageUrl || media?.url}
                    alt={`${title} for region group ${group.id}`}
                  />
                )}

                <label className='upload-change-image'>
                  <MDButton
                    sx={{
                      minWidth: '180px',
                      backgroundColor: 'rgba(255,255,255,0.9)',
                      '&:hover': {
                        backgroundColor: 'rgba(255,255,255,1)'
                      }
                    }}
                    type='button'
                    variant='outlined'
                    color='secondary'
                    component='span'
                    // onClick={() => toggleModal(group.id)} // upload device or library
                    onClick={() => handleImageOpenModal("desktop", group.id, mediaType)}
                  >
                    <div className='add-change-img-sec'>
                      <Typography variant="body2" fontWeight="semibold" mt={0.5}>Change {isVideo ? 'Video' : 'Image'} {dimensions}</Typography>
                    </div>
                  </MDButton>
                </label>

                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering the modal toggle
                    removeImage(group.id, mediaType);
                    // Clear error when image is removed
                    clearError(group.id, mediaType);
                  }}
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    zIndex: 22,
                    backgroundColor: '#ffffff',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="#2E2E3A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </IconButton>
              </Box>
            ) : (
              <Box
                // onClick={() => toggleModal(group.id)} // upload device or library
                onClick={() => handleImageOpenModal("desktop", group.id, mediaType)}
                sx={{ cursor: 'pointer' }}
              >
                <MDButton
                  sx={{
                    minWidth: '195px',
                    height: '130px',
                    border: hasError ? '0px solid #fd4438' : '0px solid #e0e0e0',
                    backgroundColor: hasError ? '#F1F1F1' : '#F1F1F1',
                    color: hasError ? '#2E2E3A' : '#2E2E3A',
                    borderRadius: '16px'
                  }}
                  type='button'
                  variant='outlined'
                  color={hasError ? 'error' : 'secondary'}
                  component='span'
                  disabled={isUploading}
                >
                  <div className='add-change-img-sec'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                      <g clipPath="url(#clip0_13676_49992)">
                        <path d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z" fill={hasError ? "#fd4438" : "#2E2E3A"} />
                      </g>
                      <defs>
                        <clipPath id="clip0_13676_49992">
                          <rect width="24" height="25" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <h5 style={{ color: hasError ? '#fd4438' : '#2E2E3A' }}>{title}</h5>
                    <Typography variant="body2" fontWeight="semibold" mt={0.5} style={{ color: hasError ? '#fd4438' : '#2E2E3A' }}>{dimensions}</Typography>
                  </div>
                </MDButton>
              </Box>
            )}
          </Badge>

          {/* Error message */}
          {hasError && (
            <FormHelperText error sx={{ width: '100%', mt: 0.5 }}>
              {errors[group.id][mediaType]}
            </FormHelperText>
          )}

          {/* Show modal options ONLY for this specific image type when modal is open */}
          {modalOpen[group.id] && (
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <MDButton
                sx={{
                  minWidth: '160px',
                  border: '1px solid #e0e0e0',
                  backgroundColor: 'white',
                  color: '#2E2E3A',
                  '&:hover': {
                    backgroundColor: '#f5f5f5'
                  }
                }}
                type='button'
                variant='outlined'
                onClick={() => {
                  toggleModal(group.id);
                }}
                disabled={isUploading}
              >
                Choose from library
              </MDButton>

              <MDButton
                sx={{
                  minWidth: '160px',
                  border: '1px solid #e0e0e0',
                  backgroundColor: 'white',
                  color: '#2E2E3A',
                  '&:hover': {
                    backgroundColor: '#f5f5f5'
                  }
                }}
                type='button'
                variant='outlined'
                component='span'
                disabled={isUploading}
                onClick={handleImageSelect}
              >
                Upload From device
              </MDButton>
            </Box>
          )}
        </Stack>
      </Box>
    );
  };


  const handleSubmit = () => {
    // Validate form before submission
    if (formData?.holidayDate === '') {
      showError('Please select date', 'error');
      return
    }
    if (!validateForm()) {
      showError('Please fix the validation errors before submitting.', 'error');
      return;
    }

    const currentUser = user?.name // Replace with actual user from your auth system
    const payload = formData.regionGroups.flatMap(group => {
      // To ensure correct date formatting, parse DateRef.current as a Date object.
      // Example: DateRef.current is "2025-10-22T18:30:00.000Z" but moment may be misparsing a string if not recognized as a date.
      // Always create moment from a Date object explicitly.


      const dateVal = DateRef.current instanceof Date ? DateRef.current : new Date(DateRef.current);
      const formattedDate = moment(dateVal).format('YYYY-MM-DD');
      // For each region in the group, create a separate payload object
      return group.regions.map(regionId => {
        // Find the region name from regionData
        const region = regionData.find(r => r.id === regionId);
        const regionName = region ? region.name : "Unknown Region";

        return {
          defaultImage: false,
          createdBy: currentUser,
          updatedBy: currentUser,
          regionId: regionId, // Single region ID
          regionName: regionName,
          desktopImages: group.desktopImage,
          mobileImages: group.mobileImage,
          date: formattedDate,
          createdDate: new Date().valueOf(),
          description: formData?.description
        };
      });
    });



    dispatch(updateHolidayByID({ payload, holidayID: HolidayDate })).unwrap().then(res => {
      showError(res?.message, 'success');
      navigate(-1)
    }).catch((err) => {
      showError(err?.message, 'error');
    });
  }

  const showError = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  const brbGraphicsByID = () => {
    dispatch(fetchHolidayByID(HolidayDate)).unwrap().then(res => {
      
      const detailHolidayData = res?.result
      DateRef.current = HolidayDate
      // setFormData(prevFormData => ({
      //   ...prevFormData,
      //   holidayDate: HolidayDate ? moment(HolidayDate, "YYYY-MM-DD") : null,
      //   description: detailsHoliday?.[0]?.description,
      //   regionGroups: detailsHoliday.map((holiday, index) => ({
      //     id: index + 1,
      //     regions: [holiday.regionId],
      //     desktopImage: holiday.desktopImages,
      //     mobileImage: holiday.mobileImages,
      //     _id: holiday._id,
      //   }))
      // }));
      setFormData(prevFormData => ({
        ...prevFormData,
        holidayDate: HolidayDate ? moment(HolidayDate, "YYYY-MM-DD") : null,
        description: res?.description || "", // Get description from first holiday
        regionGroups: detailHolidayData.map((group, index) => ({
          id: index + 1,
          regions: group.holidays.map(holiday => holiday.regionId), // Extract all regionIds from holidays array
          desktopImage: group.desktopImages, // Use desktopImages (plural) to match your desired structure
          mobileImage: group.mobileImages,   // Use mobileImages (plural) to match your desired structure
          // Remove _id if you don't need it, or include it if needed
        }))
      }));
    }).catch(() => {
    });
  }

  useEffect(() => {
    brbGraphicsByID()
  }, [])
  // Handle date change
  const handleDateChange = (newValue) => {

    DateRef.current = newValue?.format('YYYY-MM-DD')
    setFormData(prev => ({
      ...prev,
      holidayDate: newValue
    }));
  }

  return (
    <CommonLayout>
      <Box p={{ xs: 2, sm: 3, lg: 4 }} pb={{ lg: 2 }} className="create-time-slots">
        <Stack direction="row" justifyContent="space-between" flexWrap="wrap" alignItems="stretch" gap={2} mb={2}>
          <span onClick={() => navigate(-1)} className='cur-pointer'>
            <Box display="flex" gap={1} alignItems="center" color='text.main' lineHeight={1}>
              <AngleRightIcon fontSize="14px" />
              <Typography variant="h6" fontWeight="semibold" ml={0.75}>
                Holidays
              </Typography>
            </Box>
          </span>
        </Stack>
        {
          isLoading ? <Loader /> :

            <>
              <Box p={{ xs: 0 }}>
                <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: 'none' }}>
                  <Typography variant='h5' fontWeight="semibold" color="secondary">Update Holiday</Typography>
                  <Grid container spacing={2.5} mt={1} mb={2}>
                    <Grid item xs={12} md={4} lg={4}>
                      <Typography variant='body2' fontWeight="semibold" mb={1}>Select Date</Typography>
                      <FormControl fullWidth>
                        {/* <DatePicker
                    sx={{ width: '100%' }}
                    label="Date"
                    error={errors?.holidayDate}
                    helperText={errors?.holidayDate}
                    // value={formData?.holidayDate || null}
                    disablePast
                    onChange={(value) => { setFormData({ ...formData, holidayDate: value }); DateRef.current = value }}
                    slots={{
                      openPickerIcon: CalendarIcon
                    }}
                    slotProps={{
                      openPickerButton: {
                        color: 'secondary',
                      },
                    }}
                    onError={() => {
                      return Boolean(errors?.holidayDate);
                    }}
                    format='MM/DD/YYYY'
                  /> */}
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            sx={{ width: '100%' }}
                            label="Date"
                            error={errors?.holidayDate}
                            disabled
                            helperText={errors?.holidayDate}
                            value={formData?.holidayDate || null} // set as moment object or null
                            disablePast
                            onChange={handleDateChange} // Fixed: Added onChange handler
                            slots={{
                              openPickerIcon: CalendarIcon
                            }}
                            slotProps={{
                              openPickerButton: {
                                color: 'secondary',
                              },
                              textField: {
                                error: Boolean(errors?.holidayDate),
                                helperText: errors?.holidayDate,
                              }
                            }}
                            format='MM/DD/YYYY'
                          />
                        </LocalizationProvider>
                        {Boolean(errors?.holidayDate) && <FormHelperText error>{errors?.holidayDate}</FormHelperText>}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={8} lg={8}>
                      <Typography variant='body2' fontWeight="semibold" mb={1}>Description</Typography>
                      <FormControl fullWidth>
                        <TextField
                          label="Description"
                          variant="outlined"
                          rows={3}
                          value={formData?.description || ""}
                          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                          error={Boolean(errors?.description)}
                          helperText={errors?.description}
                          fullWidth
                        />
                      </FormControl>
                    </Grid>
                  </Grid>

                  {/* Region Groups */}
                  {formData.regionGroups.map((group) => {
                    const selectedRegionNames = getSelectedRegionNames(group.regions);
                    const isAllSelected = isAllDriverSelected(group.regions);
                    const hasRegionError = errors[group.id] && errors[group.id].regions;
                    const availableRegions = getAvailableRegions();

                    return (
                      <Box key={group.id}>
                        <Typography variant="h6" color="#2E2E3A" mt={2} mb={1}>
                          Regions
                        </Typography>
                        <Card
                          sx={{
                            borderRadius: 2.5,
                            boxShadow: 'none',
                            background: "#f5f5ff99",
                            mb: 2,
                            border: hasRegionError ? '1px solid #fd4438' : 'none'
                          }}
                          style={{ padding: "20px" }}
                        >
                          <Box
                            className='time-sec-rep'
                            style={{ background: "#ffffff", padding: "20px", borderRadius: "20px", border: "1px solid #F2F3F7" }}
                          >
                            {/* Region Selection */}
                            <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "20px", mt: 2, mb: 2 }}>
                              <Box style={{ width: "340px" }}>
                                <FormControl fullWidth error={hasRegionError}>
                                  <InputLabel id={`select-region-label-${group.id}`}>Select Region</InputLabel>
                                  <Select
                                    size='small'
                                    className='form-select'
                                    labelId={`select-region-label-${group.id}`}
                                    id={`select-region-${group.id}`}
                                    multiple
                                    value={group.regions || []}
                                    fullWidth
                                    MenuProps={MenuProps}
                                    onChange={(event, child) => {
                                      // Prevent "Select All" click (when not clicking the selectAll checkbox) from adding an undefined region id
                                      let value = event.target.value;
                                      // If value contains undefined, filter it out
                                      if (Array.isArray(value)) {
                                        value = value.filter((v) => typeof v !== 'undefined');
                                      }
                                      // If the event was triggered by clicking a MenuItem (not the selectAll checkbox), 
                                      // and value includes undefined, ignore/select nothing new
                                      updateGroupRegions(group.id, value);
                                      // Clear region error when user selects something
                                      if (errors[group.id]?.regions && value.length > 0) {
                                        clearError(group.id, 'regions');
                                      }
                                    }}
                                    input={<OutlinedInput label='Select Region' />}
                                    renderValue={() =>
                                      isAllSelected
                                        ? 'All Regions'
                                        : `${group.regions.length} Region${group.regions.length !== 1 ? 's' : ''}`
                                    }
                                  >
                                    <MenuItem
  sx={{ ...selectAll, backgroundColor: isAllSelected ? '#f0f2f5' : '' }}
>
  <Box 
    sx={{ width: '100%' }}
    onClick={(e) => {
      if (availableRegions.length === 0 && !isAllSelected) return;
      
      if (isAllSelected) {
        updateGroupRegions(group.id, []);
      } else {
        updateGroupRegions(group.id, regionData?.map((item => item?.id)));
      }
      if (errors[group.id]?.regions) {
        clearError(group.id, 'regions');
      }
    }}
  >
    <FormControlLabel
      control={
        <Checkbox
          sx={{ p: 0.4, mr: 1, ml: 1.25 }}
          checked={isAllSelected}
          disabled={availableRegions.length === 0 && !isAllSelected}
          onClick={(e) => {
            e.stopPropagation();
          }}
          onChange={(e) => {
            if (e.target.checked) {
              updateGroupRegions(group.id, regionData?.map((item => item?.id)));
            } else {
              updateGroupRegions(group.id, []);
            }
            if (errors[group.id]?.regions) {
              clearError(group.id, 'regions');
            }
          }}
        />
      }
      label={regionData.length ? 'Select All' :
        <>
          Fetching regions..
          <CircularProgress
            style={{
              marginTop: '-4px',
              marginLeft: '6px'
            }}
            size={12}
            color='primary'
            justifyContent='flex-end'
          />
        </>
      }
    />
  </Box>
</MenuItem>
                                    {/* <MenuItem
                                      sx={{ ...selectAll, backgroundColor: isAllSelected ? '#f0f2f5' : '' }}
                                      onClick={(e) => {
                                        // Prevent MenuItem click (outside of checkbox) from toggling all
                                        // Instead, only click on the checkbox toggles all. So stop propagation here.
                                        e.preventDefault();
                                        e.stopPropagation();
                                      }}
                                    >
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            sx={{ p: 0.4, mr: 1, ml: 1.25 }}
                                            checked={isAllSelected}
                                            disabled={availableRegions.length === 0 && !isAllSelected}

                                            // Only allow toggle by clicking checkbox
                                            onClick={e => e.stopPropagation()}
                                            onChange={(e) => {
                                              if (e.target.checked) {
                                                updateGroupRegions(group.id, regionData?.map((item => item?.id)));
                                              } else {
                                                updateGroupRegions(group.id, []);
                                              }
                                              // Clear region error when user selects all
                                              if (errors[group.id]?.regions) {
                                                clearError(group.id, 'regions');
                                              }
                                            }}
                                          />
                                        }
                                        label={regionData.length ? 'Select All' :
                                          <>
                                            Fetching regions..
                                            <CircularProgress
                                              style={{
                                                marginTop: '-4px',
                                                marginLeft: '6px'
                                              }}
                                              size={12}
                                              color='primary'
                                              justifyContent='flex-end'
                                            />
                                          </>
                                        }
                                      />
                                    </MenuItem> */}
                                    {regionData?.map((region) => (
                                      <MenuItem sx={{ px: 1 }} key={region.id} value={region?.id} disabled={isRegionDisabled(region.id, group.id)}>
                                        <Checkbox
                                          sx={{ p: 0.4, mr: 1 }}
                                          checked={group.regions?.indexOf(region?.id) > -1}
                                        />
                                        {region?.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {hasRegionError && (
                                    <FormHelperText error>{errors[group.id].regions}</FormHelperText>
                                  )}
                                </FormControl>
                              </Box>

                              <Stack direction="row" flexWrap="wrap" alignItems="stretch" gap={1.5} className="close-add-icons">
                                {formData.regionGroups.length > 1 && (
                                  <IconButton onClick={() => handleRemoveGroup(group.id)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                      <path d="M5.5 16.5L16.5 5.5M5.5 5.5L16.5 16.5" stroke="#2E2E3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                  </IconButton>
                                )}
                              </Stack>
                            </Box>

                            {/* Display selected regions with cross icons */}
                            {selectedRegionNames.length > 0 && (
                              <Box sx={{ mb: 2 }}>
                                {/* <Typography variant="body2" color="text.secondary" mb={1}>
                            Regions
                          </Typography> */}
                                <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: "8px" }}>
                                  {selectedRegionNames.map((region) => (
                                    <Typography variant='body2' fontWeight="medium" key={region.id} component="span" sx={{ borderRadius: "6px", background: "#F1F1F1", display: 'inline-flex', alignItems: 'center', padding: "8px 10px", lineHeight: "normal", color: "#2E2E3A", fontSize: "12px" }}>
                                      {region.name}
                                      <IconButton
                                        size="small"
                                        onClick={() => handleRemoveRegion(group.id, region.id)}
                                        sx={{ ml: 0.5, p: 0 }}
                                      >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ background: "#FD4438", borderRadius: "50%", padding: "2px" }}>
                                          <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                      </IconButton>
                                    </Typography>
                                  ))}
                                  {group.regions.length > 0 && (
                                    <Typography
                                      variant="body2"
                                      color="#2E2E3A"
                                      fontWeight="semibold"
                                      fontSize="12px"
                                      sx={{
                                        cursor: 'pointer',
                                        textDecoration: 'underline'
                                      }}
                                      onClick={() => handleRemoveAllRegions(group.id)}
                                    >
                                      Clear All
                                    </Typography>
                                  )}
                                </Box>
                              </Box>
                            )}

                            <Box display="flex" alignItems="start" mt={4} gap={2}>

                      
                              {/* Desktop Image */}
                              <ImageUploadSection
                                group={group}
                                mediaType="desktopImage"
                                title="Desktop"
                                dimensions="1252×560"
                                toggleModal={toggleDesktopImageModal}
                                modalOpen={desktopImageModalOpen}
                              />

                              {/* Mobile Image */}
                              <ImageUploadSection
                                group={group}
                                mediaType="mobileImage"
                                title="Mobile"
                                dimensions="406×180"
                                toggleModal={toggleMobileImageModal}
                                modalOpen={mobileImageModalOpen}
                              />
                            </Box>
                          </Box>
                        </Card>
                      </Box>
                    );
                  })}

                  {/* Add Region Group Button */}
                  {
                    !areAllRegionsUsed() && 
                    <Box sx={{ display: 'flex', mt: 2 }}>
                      <Button
                        startIcon={<AddRoundedIcon fontSize='large' />}
                        variant='contained'
                        color='primary'
                        size='small'
                        sx={{ minWidth: '160px', backgroundColor: '#2E2E3A !important', boxShadow: "none !important" }}
                        style={{ textTransform: 'none', minHeight: '35px', padding: "8px 20px" }}
                        onClick={handleAddRegionGroup}
                      >
                        Add Region
                      </Button>
                  </Box>
                  }

                  {/* {areAllRegionsUsed() && (
                            <Box sx={{ mt: 2, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                                <Typography variant="body2" color="text.secondary">
                                    All regions have been assigned. You cannot add more region groups.
                                </Typography>
                            </Box>
                        )} */}
                 
                </Card>
              </Box>
              <Box p={{ xs: 0 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12} lg={12}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} mt={4} mb={4}>
                      <MDButton
                        sx={{ minWidth: '150px' }}
                        type='submit'
                        variant='contained'
                        onClick={handleSubmit}
                        color={'primary'}
                        disabled={isLoading || isUpdateLoading}                >
                        {isLoading || isUpdateLoading ? <CircularProgress size={14} justifyContent="center" style={{ color: "#ffffff" }} /> : 'Update'}
                      </MDButton>
                      <MDButton
                        sx={{ minWidth: '150px' }}
                        type='button'
                        variant='outlined'
                        color='dark'
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </MDButton>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>
            </>
        }
      </Box>
    </CommonLayout>
  )
}

export default EditHolidayByDate